import React from "react";
import MainLayout from "@/components/layout/MainLayout";
import { useTranslation } from "react-i18next";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

const LegalInfo = () => {
  const { t } = useTranslation();
  return (
    <MainLayout>
      <div className="container px-4 mx-auto py-6">
        <div className="max-w-4xl mx-auto">
          <div className="mb-6">
            <h1 className="text-2xl font-bold text-foreground mb-2">{t('legal.title')}</h1>
            <p className="text-muted-foreground">
              {t('legal.subtitle')}
            </p>
          </div>

          <div className="space-y-6">
            {/* Информация о владельце */}
            <Card>
              <CardHeader>
                <CardTitle className="text-lg">{t('legal.contacts_title')}</CardTitle>

              </CardHeader>
              <CardContent className="space-y-2">
                <p className="text-sm text-foreground">
                  {t('legal.owner_name')}
                </p>
                <p className="text-sm text-foreground">
                  <strong>{t('legal.inn')}:</strong> 272109048195
                </p>
                <p className="text-sm text-foreground">
                  <strong>{t('legal.email_label')}:</strong>{" "}
                  <a href="mailto:support@voice2doc.com" className="text-brand-500 hover:text-brand-600 underline">
                    support@voice2doc.com
                  </a>
                </p>
              </CardContent>
            </Card>

            {/* Документы */}
            <Card>
              <CardHeader>
                <CardTitle className="text-lg">{t('legal.docs_title')}</CardTitle>
                <CardDescription>{t('legal.docs_subtitle')}</CardDescription>
              </CardHeader>
              <CardContent>
                <div className="grid gap-4 sm:grid-cols-1 md:grid-cols-3">
                  <a
                    href="https://voice2doc.com/terms"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block p-4 border border-border rounded-lg hover:border-brand-300 hover:bg-brand-50 transition-colors"
                  >
                    <h3 className="font-medium text-foreground mb-1">{t('legal.terms_title')}</h3>
                    <p className="text-sm text-muted-foreground">{t('legal.terms_desc')}</p>
                  </a>

                  <a
                    href="https://voice2doc.com/privacy"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block p-4 border border-border rounded-lg hover:border-brand-300 hover:bg-brand-50 transition-colors"
                  >
                    <h3 className="font-medium text-foreground mb-1">{t('legal.privacy_title')}</h3>
                    <p className="text-sm text-muted-foreground">{t('legal.privacy_desc')}</p>
                  </a>

                  <a
                    href="https://voice2doc.com/consent"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block p-4 border border-border rounded-lg hover:border-brand-300 hover:bg-brand-50 transition-colors"
                  >
                    <h3 className="font-medium text-foreground mb-1">{t('legal.consent_title')}</h3>
                    <p className="text-sm text-muted-foreground">{t('legal.consent_desc')}</p>
                  </a>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default LegalInfo;
